import { AboutAIResponse } from '../components/AboutAIResponse/AboutAIResponse'
import { FashionAssistantGrid } from '../components/FashionAssistantGrid/FashionAssistantGrid'
import { FeedbackQuickReplies } from '../components/FeedbackQuickReplies/FeedbackQuickReplies'
import { IceBreakers } from '../components/IceBreakers/IceBreakers'
import { LeaveAgentQueueButton } from '../components/LeaveAgentQueueButton/LeaveAgentQueueButton'
import { OrderList } from '../components/OrderList/OrderList'
import { PlainMessage } from '../components/PlainMessage/PlainMessage'
import {
	type AITextMessage,
	type AboutAIMessage,
	type AgentTextMessage,
	type FashionAssistantMessage,
	type InitIceBreakersMessage,
	type LeaveAgentQueue,
	MessageType,
	type QuestionMessage,
	type QuickRepliesMessage,
	type ReplyOrderListMessage,
} from '../types/messageTypes'

// biome-ignore lint/complexity/noBannedTypes: fix this
export const ContentMessages: Record<MessageType, Function> = {
	[MessageType.InitIceBreakers]: (message: InitIceBreakersMessage) => (
		<IceBreakers message={message} />
	),
	[MessageType.Question]: (message: QuestionMessage) => (
		<PlainMessage message={message} />
	),
	[MessageType.AIText]: (message: AITextMessage) => (
		<PlainMessage message={message} />
	),
	[MessageType.OrderList]: (message: ReplyOrderListMessage) => (
		<OrderList message={message} />
	),
	[MessageType.QuickReplies]: (message: QuickRepliesMessage) => (
		<FeedbackQuickReplies message={message} />
	),
	[MessageType.FashionAssistant]: (message: FashionAssistantMessage) => (
		<FashionAssistantGrid message={message} />
	),
	[MessageType.AgentText]: (message: AgentTextMessage) => (
		<PlainMessage message={message} />
	),
	[MessageType.AboutAI]: (message: AboutAIMessage) => (
		<AboutAIResponse message={message} />
	),
	[MessageType.LeaveAgentQueue]: (message: LeaveAgentQueue) => (
		<LeaveAgentQueueButton message={message} />
	),
}
